// TODO: Promote any overrides in this file to the Omni UI Asset IQ Theme.
import { OmniLightTheme as BaseTheme, OmniTheme } from '@aiz-gl/omni-ui';

export const palette = {
  primary: '#163C73',
  secondary: '#3E8AEE',
  tertiary: '#3E8AEE',
  quaternary: '#F8FAFC',
  warn: '#ef4444',
  success: '#10b981',
  light: '#f1f5f9',
  onLight: '#0f172a',
  onLightVariant: '#64748b',
  medium: '#cbd5e1',
  dark: '#334155',
  onDark: '#FFF',
  background: '#eef3f8',
  white: '#fff',
  disabled: 'rgba(0,0,0,0.12)',
  onDisabled: 'rgba(0,0,0,0.5)',
};

export const LightTheme: OmniTheme = {
  ...BaseTheme,
  name: 'Asset IQ Light',

  colors: {
    primary: palette.primary,
    'on-primary': palette.onDark,

    secondary: palette.secondary,
    'on-secondary': palette.onDark,

    tertiary: palette.tertiary,
    'on-tertiary': palette.onDark,

    quaternary: palette.quaternary,
    'on-quaternary': palette.onDark,

    warn: palette.warn,
    'on-warn': palette.onDark,

    success: palette.success,
    'on-success': palette.onDark,

    disabled: '#b3b3b3',
    'on-disabled': palette.onDark,

    light: palette.light,
    onLight: palette.onLight,

    dark: palette.dark,
    onDark: palette.onDark,

    'primary-container': palette.white,
    'on-primary-container': palette.onLight,
    'on-primary-container-variant': palette.secondary,
    'on-primary-container-border': palette.medium,

    'secondary-container': palette.light,
    'on-secondary-container': palette.onLight,
    'on-secondary-container-variant': palette.onLightVariant,
    'on-secondary-container-border': palette.medium,

    'tertiary-container': palette.quaternary,
    'on-tertiary-container': palette.onLight,
    'on-tertiary-container-variant': palette.onLightVariant,
    'on-tertiary-container-border': palette.medium,

    'warn-container': '#ffc2b3',
    'on-warn-container': palette.warn,
    'on-warn-container-variant': palette.onLightVariant,
    'on-warn-container-border': palette.warn,

    'success-container': '#b3e7c2',
    'on-success-container': palette.success,
    'on-success-container-variant': palette.onLightVariant,
    'on-success-container-border': palette.success,

    'disabled-container': '#f2f2f2',
    'on-disabled-container': palette.onLight,

    'primary-surface': palette.background,
    'on-primary-surface': palette.onLight,
    'on-primary-surface-variant': palette.primary,

    'secondary-surface': '#cce4f1',
    'on-secondary-surface': palette.onLight,
    'on-secondary-surface-variant': palette.primary,

    'tertiary-surface': '#f2f2f2',
    'on-tertiary-surface': palette.onLight,
    'on-tertiary-surface-variant': palette.primary,

    'quaternary-surface': '#abcde5',
    'on-quaternary-surface': palette.onLight,
    'on-quaternary-surface-variant': palette.primary,

    'disabled-surface': palette.disabled,
    'on-disabled-surface': palette.onDisabled,
    'on-disabled-surface-variant': palette.onLightVariant,

    'inverse-surface': palette.dark,
    'on-inverse-surface': palette.onDark,
    'on-inverse-surface-variant': '#cce4f1',

    background: palette.white,
    'on-background': palette.onLight,
    'on-background-variant': '#959595',

    scrim: 'rgba(0,0,0,0.2)',
    ghost: 'transparent',
    transparent: 'transparent',
  },

  borders: {
    ...BaseTheme.borders,
    tertiary: `1px solid ${palette.medium}`,
    dark: `1px solid ${palette.dark}`,
  },

  spacing: {
    none: '0px',
    // xxs: 2px → min 1px → vw ≈ 0.104vw
    xxs: 'clamp(1px, 0.104vw, 2px)',
    xs: 'clamp(2px, 0.208vw, 4px)',
    sm: 'clamp(5px, 0.416vw, 8px)',
    md: 'clamp(10px, 0.833vw, 16px)',
    lg: 'clamp(20px, 1.666vw, 32px)',
    xl: 'clamp(36px, 3.333vw, 64px)',
  },

  radii: {
    none: 'none',
    xxs: '2px',
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '24px',
    max: '999px',
  },

  components: {
    ...BaseTheme.components,
    badge: {
      options: {
        borderRadius: 'max',
      },
    },
    button: {
      ...BaseTheme.components.button,
      fixed: {
        ...BaseTheme.components.button?.fixed,
        fontFamily: 'Inter Light, sans-serif',
        transform: 'none !important',
        transition: 'box-shadow 0.2s ease-in-out !important',
      },
      colors: {
        ...BaseTheme.components.button?.colors,
        primary: {
          color: palette.white,
          backgroundColor: palette.primary,
          border: `1px solid ${palette.primary} !important`,
        },
        secondary: {
          color: palette.white,
          backgroundColor: palette.secondary,
          border: `1px solid ${palette.secondary} !important`,
        },
        tertiary: {
          color: palette.white,
          backgroundColor: palette.tertiary,
          border: `1px solid ${palette.tertiary} !important`,
        },
      },
      sizes: {
        ...BaseTheme.components.button?.sizes,
        lg: {
          height: 30,
          borderRadius: 15,
          fontSize: 18,
          padding: '0 12px',
        },
      },
    },
    dataSearch: {
       ...BaseTheme.components.dataSearch,
      options: {
        border: 'light',
        borderRadius: 'md',
        color: 'primary-surface',
        placeholderColor: 'disabled',
      },
    },
    dataTable: {
      ...BaseTheme.components.dataTable,
      options: {
        color: 'primary-container',
        border: 'none',
        borderRadius: 'md',
        elevation: 'none',
        headerPadding: 'md',
        footerPadding: 'sm',
        thColor: 'tertiary-surface',
        thPadding: 'sm',
        thVerticalBorder: 'none',
        thHorizontalBorder: 'tertiary',
        thTextRole: 'headline-small',
        tdColor: 'primary-surface',
        tdPadding: 'sm',
        tdTextRole: 'body-2-long',
        tdStickyColor: 'tertiary-surface',
        tdHorizontalPadding: 'sm',
        tdVerticalBorder: 'none',
        tdHorizontalBorder: 'light',
        rowHoverColor: 'tertiary-surface',
      },
    },
    dialog: {
      ...BaseTheme.components.dialog,
      options: {
        ...BaseTheme.components.dialog?.options,
        border: 'none',
        borderRadius: 'lg',
        padding: 'none',
        backdrop: {
          background: 'rgba(0, 0, 0, 0.38)',
          backdropFilter: 'blur(4px)',
        },
      },
    },
  },

  typeFaces: {
    ...BaseTheme.typeFaces,

    'display-large': {
      fontFamily: 'Alphapipe, sans-serif',
      // 50px at 1920px => 50 / 19.2 = 2.604vw
      fontSize: 'clamp(32px, 2.604vw, 50px)',
      // lineHeight max=60px, vw=60/19.2=3.125vw, min≈42px
      lineHeight: 'clamp(42px, 3.125vw, 60px)',

      letterSpacing: '-0.25px',
    },
    'display-medium': {
      fontFamily: 'Alphapipe, sans-serif',
      // 40px at 1920px => 40 / 19.2 = 2.083vw
      fontSize: 'clamp(28px, 2.083vw, 40px)',
      lineHeight: 'clamp(36px, 2.708vw, 52px)',
      letterSpacing: '-0.25px',
    },
    'display-small': {
      fontFamily: 'Alphapipe, sans-serif',
      // 36px at 1920px => 36 / 19.2 = 1.875vw
      fontSize: 'clamp(24px, 1.875vw, 36px)',
      lineHeight: 'clamp(32px, 2.188vw, 42px)',
    },

    'headline-large': {
      fontFamily: 'Inter Black, sans-serif',
      // 24px at 1920px => 24 / 19.2 = 1.25vw
      fontSize: 'clamp(18px, 1.25vw, 24px)',
      lineHeight: 'clamp(24px, 1.667vw, 32px)',
      letterSpacing: '-0.01px',
    },
    'headline-medium': {
      fontFamily: 'Inter Bold, sans-serif',
      // 20px at 1920px => 20 / 19.2 = 1.042vw
      fontSize: 'clamp(16px, 1.042vw, 20px)',
      lineHeight: 'clamp(20px, 1.458vw, 28px)',
      letterSpacing: '0.15px',
    },
    'headline-small': {
      fontFamily: 'Inter Bold, sans-serif',
      // 16px at 1920px => 16 / 19.2 = 0.833vw
      fontSize: 'clamp(14px, 0.833vw, 16px)',
      lineHeight: 'clamp(18px, 1.146vw, 22px)',
      letterSpacing: '0.1px',
    },

    'title-large': {
      fontFamily: 'Inter Light, sans-serif',
      // 24px => 1.25vw
      fontSize: 'clamp(18px, 1.25vw, 24px)',
      lineHeight: 'clamp(24px, 1.667vw, 32px)',
    },
    'title-medium': {
      fontFamily: 'Inter Semibold, sans-serif',
      // 20px => 1.042vw
      fontSize: 'clamp(16px, 1.042vw, 20px)',
      lineHeight: 'clamp(21px, 1.458vw, 28px)',
      letterSpacing: '0.15px',
    },
    'title-small': {
      fontFamily: 'Inter Light, sans-serif',
      // 18px => 0.938vw
      fontSize: 'clamp(14px, 0.938vw, 18px)',
      lineHeight: 'clamp(20px, 1.146vw, 22px)',
      letterSpacing: '0.1px',
    },

    'body-1-long': {
      fontFamily: 'Inter Light, sans-serif',
      // 16px => 0.833vw
      fontSize: 'clamp(14px, 0.833vw, 16px)',
      lineHeight: 'clamp(20px, 1.146vw, 22px)',
    },
    'body-1-short': {
      fontFamily: 'Inter Light, sans-serif',
      // 16px => 0.833vw
      fontSize: 'clamp(14px, 0.833vw, 16px)',
      lineHeight: 'clamp(22px, 1.25vw, 24px)',
    },
    'body-2-long': {
      fontFamily: 'Inter Light, sans-serif',
      // 14px => 0.729vw
      fontSize: 'clamp(12px, 0.729vw, 14px)',
      lineHeight: 'clamp(16px, 0.938vw, 18px)',
    },
    'body-2-short': {
      fontFamily: 'Inter Light, sans-serif',
      // 14px => 0.729vw
      fontSize: 'clamp(12px, 0.729vw, 14px)',
      lineHeight: 'clamp(18px, 1.042vw, 20px)',
    },

    badge: {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: 'clamp(14px, 0.833vw, 16px)',
      lineHeight: '24px',
    },
  },
};
